/* tslint:disable:indent */
import { AjouterMessages } from './ajouter-messages';
import { BoutonMessages } from './bouton-messages';
import { ErreurMessages } from './erreur-messages';
import { IntroductionMessages } from './introduction-messages';

const erreurMessages = new ErreurMessages();
const introductionMessages = new IntroductionMessages();
const ajouterMessages = new AjouterMessages();
const boutonMessages = new BoutonMessages();

export class SteppeurMessages {
  public nbErreurCorriger = erreurMessages.nbErreurCorriger;
  public erreurLibelle = erreurMessages.libelle;
  public aCorriger = erreurMessages.aCorriger;
  public introductionLibelle = introductionMessages.libelle;
  public informationLibelle = 'stepper.informations';
  public identifiantLibelle = 'stepper.identifiant';
  public contactLibelle = 'stepper.contact';
  public ajouterDocumentComplementaire = ajouterMessages.documentComplementaire;
  public ajouterValiderCreation = ajouterMessages.validerCreation;
  public boutonPrecedent = boutonMessages.precedent;
  public boutonSignaler = boutonMessages.signaler;
  public boutonSuivant = boutonMessages.suivant;
  public boutonContinuer = boutonMessages.continuer;
  public boutonValiderForm = boutonMessages.validerForm;
  public boutonValiderStep = boutonMessages.validerStep;
  public boutonEnregistrer = boutonMessages.enregistrer;
  public boutonAjoutSection = boutonMessages.ajouter_section;
  public boutonEnvoyer = boutonMessages.envoyer;
  public demarrerDemande = boutonMessages.demarrerDemande;

  constructor() {
  }
}
